module.exports = __webpack_public_path__ + "img/bj-screenshot4.70206b24.png";